module.exports = __webpack_public_path__ + "poppins-medium_0-webfont.36977f2b1edf74fb43e4.eot";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/poppins-medium_0-webfont.eot
// module id = ../../../../../src/assets/fonts/poppins-medium_0-webfont.eot
// module chunks = 2